export default __webpack_public_path__ + "static/media/main-cover.7abb0bc3.jpg";